const MasterPages = {
  email: {
    icon: 'mail',
    title: 'Email',
    color: 'primary',
    link: 'email',
    content: 'Quickly send emails to groups'
  },
  compliance: {
    icon: 'security',
    title: 'Compliance',
    color: 'primary',
    link: 'compliance',
    content: 'Compliance register'
  },
  audit: {
    icon: 'history',
    title: 'Audits',
    color: 'blue-grey',
    // color: "green darken-2",
    link: 'audit',
    content: 'View audits'
  },
  tipping: {
    icon: 'delete_sweep',
    title: 'Tipping',
    color: 'red darken-4',
    link: 'tipping',
    content: 'Import and manage tipping dockets'
  },
  docket: {
    icon: 'create_new_folder',
    title: 'Dockets',
    color: 'blue darken-4',
    link: 'docket',
    content: 'Add, modify and see an overview of dockets',
    showOnMainPage: true
  },
  allocation: {
    icon: 'assignment',
    title: 'Allocations',
    color: 'cyan darken-3',
    link: 'allocation',
    content: 'View allocations and create dockets',
    showOnMainPage: true
  },
  allocationStaging: {
    title: 'Allocation Staging',
    content: 'Prepare and commit staged allocations',
    color: 'cyan darken-3',
    icon: 'gavel',
    link: 'allocationStaging'
  },
  rcti: {
    icon: 'receipt',
    title: 'RCTIs',
    color: 'green',
    link: 'rcti',
    content: 'Modify and organise RCTIs',
    showOnMainPage: true
  },
  billing: {
    icon: 'folder_shared',
    title: 'Billing',
    color: 'orange',
    link: 'billing',
    content: 'Modify and organise Billing',
    showOnMainPage: true
  },
  approvedBillLine: {
    icon: 'folder_shared',
    title: 'Approved Bill Lines',
    color: 'orange lighten-2',
    link: 'approvedBillLine',
    content: 'Modify and organise Approved Billing'
    // showOnMainPage: true
  },
  client: {
    title: 'Clients',
    content: 'Add, modify and delete Clients',
    //color: "purple",
    color: 'purple darken-2',
    icon: 'people',
    link: 'client'
  },
  project: {
    title: 'Projects',
    content: 'Add, modify and delete Projects',
    //color: "blue-grey",
    color: 'purple',
    icon: 'note',
    link: 'project'
  },
  rate: {
    title: 'Rates',
    content: 'Add, modify and delete Rates',
    color: 'green darken-2',
    //icon: "attach_money",
    icon: 'credit_card',
    link: 'rate',
    endOfCategory: true
  },
  rateDetail: {
    color: 'green darken-2',
    icon: 'attach_money'
  },
  site: {
    title: 'Sites',
    content: 'Add, modify and delete Sites',
    //color: "indigo",
    color: 'purple lighten-2',
    icon: 'location_on',
    link: 'site'
    // endOfCategory: true
  },
  tip: {
    title: 'Tips',
    content: 'Add, modify and delete Tips',
    color: 'red darken-4',
    icon: 'delete_sweep',
    link: 'tip'
  },
  spoil: {
    title: 'Spoils',
    content: 'Add, modify and delete Spoils',
    //color: "lime darken-2",
    color: 'red darken-1',
    icon: 'loop',
    link: 'spoil',
    endOfCategory: true
  },
  contractor: {
    title: 'Sub-contractors',
    content: 'Add, modify and delete Sub-contractors',
    //color: "light-blue darken-2",
    color: 'teal darken-2',
    icon: 'recent_actors',
    link: 'contractor'
  },
  vehicle: {
    title: 'Vehicles',
    content: 'Add, modify and delete Vehicles',
    color: 'teal',
    icon: 'local_shipping',
    link: 'vehicle'
  },
  vehicleType: {
    title: 'Vehicle Types',
    content: 'Add, modify and delete Vehicle Types',
    color: 'teal',
    icon: 'build',
    link: 'vehicleType'
  },
  driver: {
    title: 'Drivers',
    content: 'Add, modify and delete Drivers',
    //color: "pink",
    color: 'teal lighten-2',
    icon: 'person',
    link: 'driver',
    endOfCategory: true
  },
  report: {
    title: 'Reports',
    content: 'See reports of data in various formats',
    color: 'red',
    icon: 'file_copy',
    link: 'report'
  },
  showReport: {
    color: 'red',
    icon: 'file_copy',
    link: 'showReport'
  },
  user: {
    icon: 'supervised_user_circle',
    content: 'Organise and edit users and user permissions',
    title: 'Users',
    color: 'pink',
    link: 'user'
  },
  userAuthClass: {
    icon: 'security',
    content: 'Review user authorization rules',
    title: 'User Authorization',
    color: 'pink',
    link: 'userAuthClass'
  },
  settings: {
    icon: 'settings',
    content: 'Add and edit billing periods',
    title: 'Settings',
    color: 'deep-purple',
    link: 'settings'
  }
}

export default {
  topLevelPages: [
    MasterPages.user,
    MasterPages.settings,
    MasterPages.allocation,
    MasterPages.docket,
    MasterPages.rcti,
    MasterPages.billing,
    MasterPages.approvedBillLine,
    MasterPages.tipping,
    MasterPages.compliance,
    MasterPages.email,
    // MasterPages.rate,
    MasterPages.audit
  ],
  minorPages: [
    // MasterPages.trip,
    MasterPages.client,
    MasterPages.project,
    MasterPages.site,
    MasterPages.rate,
    MasterPages.tip,
    MasterPages.spoil,
    MasterPages.contractor,
    MasterPages.vehicle,
    MasterPages.driver
    //MasterPages.report
  ],
  pages: MasterPages
  // pages: {
  //     client: MasterPages.client,
  //     project: MasterPages.project,
  //     site: MasterPages.site,
  //     rate: MasterPages.rate,
  //     rateDetail: MasterPages.rate,
  //     tip: MasterPages.tip,
  //     spoil: MasterPages.spoil,
  //     contractor: MasterPages.contractor,
  //     vehicle: MasterPages.vehicle,
  //     vehicleType: MasterPages.vehicleType,
  //     driver: MasterPages.driver,
  //     allocation: MasterPages.allocation,
  //     docket: MasterPages.docket,
  //     trip: MasterPages.Trip,
  //     rcti: MasterPages.rcti,
  //     confirmedTrip: MasterPages.confirmedTrip,
  //     confirmedTripBilling: MasterPages.confirmedTripBilling,
  //     billing: MasterPages.billing,
  //     report: MasterPages.report
  // }
}
